<template>
  <div class="customer-note">
    <div class="customer-note-header">
      <time>{{ noteDate }}</time>

      <a
        href="#"
        class="customer-note-edit"
        @click.prevent="editNote(noteData.id, noteData.note, noteData.notification_field)">
        <icon
          name="edit"
          size="xxs"
          primaryColor="color-notice" />
        {{ $t('common.ui.edit') }}
      </a>
    </div>

    <p>{{ noteData.note }}</p>

    <div
      v-if="noteData.notification_field"
      class="customer-note-notification-field">
      {{ $t('customerNotePopup.notificationField') }}:
      <strong v-pure-html="'{' + noteData.notification_field + '}'"></strong>
    </div>

    <btn
      :type="removeInProgress ? 'loader icon' : 'icon'"
      :title="$t('customerNote.remove')"
      @click.native="removeNote(noteData.id)"
      :disabled="removeInProgress"
      :iconName="!removeInProgress ? 'trash' : 'loader'"
      :iconColor="!removeInProgress ? 'color-text-light' : 'color-danger'" />
  </div>
</template>

<script>
import ErrorUtils from './../helpers/ErrorUtils.js';

export default {
  name: 'customer-note',
  props: ['noteData', 'customerID', 'notificationFields'],
  data () {
    return {
      removeInProgress: false
    };
  },
  computed: {
    noteDate () {
      let dateFormat = 'D MMMM YYYY HH:mm:ss';
      let noteDate = this.noteData.created_at;
      noteDate = noteDate.split(' ');
      noteDate[0] = noteDate[0].split('-');
      noteDate[1] = noteDate[1].split(':');
      noteDate[0][1] = parseInt(noteDate[0][1], 10) - 1;
      let newTimestamp = new Date(noteDate[0][0], noteDate[0][1], noteDate[0][2], noteDate[1][0], noteDate[1][1], noteDate[1][2]);

      return this.$moment(newTimestamp).format(dateFormat);
    }
  },
  methods: {
    editNote (id, text, notificationField) {
      this.$bus.$emit('show-customer-note-form', {
        id: id,
        customerID: this.customerID,
        notification_field: notificationField,
        notificationFields: this.notificationFields,
        text: text
      });
    },
    removeNote (id) {
      this.removeInProgress = true;

      this.$http.post('/panel/customers/customer-remove-note', {
        id: id,
        customer_id: this.customerID
      }).then(response => {
        this.$bus.$emit('customer-notes-reload-needed');

        this.$bus.$emit('notification-display', {
          message: this.$t('customerNote.removed'),
          type: 'success'
        });

        this.removeInProgress = false;
      }).catch(error => {
        ErrorUtils.handleSubmitError(error, '/panel/customers/customer-remove-note', this.$router, this.$bus, this.removeNote.bind(this, id));
        this.removeInProgress = false;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.customer-note {
  background: $color-light;
  border-radius: $border-radius-small;
  margin-bottom: 1rem;
  padding: 1.5rem 8rem 1.5rem 2rem;
  position: relative;

  p {
    color: $color-text-dark;
    font-size: 1.3rem;
    line-height: 1.4;
    margin: 0;
  }

  .button {
    position: absolute;
    right: 2rem;
    top: 50%;
    transform: translateY(-50%);
  }

  &-notification-field {
    font-size: 12px;
    margin-top: 1rem;
  }

  &-header {
    font-size: 1.3rem;
    margin-bottom: 1rem;

    time {
      margin-right: 2rem;
    }

    a {
      .icon {
        position: relative;
        top: .1rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/CustomerNote.vue